import { render } from "./UsuariosAdmin.vue?vue&type=template&id=7366edc8"
import script from "./UsuariosAdmin.vue?vue&type=script&lang=js"
export * from "./UsuariosAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__